(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-catch-moment"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.currentScript.closest('.shopify-section') || document;
    const section = root.querySelector('.cm');
    if (!section) return;

    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          section.classList.add('is-live');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.25 });

    io.observe(section);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-season-wheel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.currentScript.closest('.shopify-section') || document;
    const stage = root.querySelector('.sw');
    if (!stage) return;

    const setSeason = (value) => {
      if (value) {
        stage.setAttribute('data-season', value);
        stage.querySelectorAll('.sw-wedge').forEach((w) => {
          w.classList.toggle('is-on', w.dataset.wedge === value);
        });
      } else {
        stage.removeAttribute('data-season');
        stage.querySelectorAll('.sw-wedge').forEach((w) => w.classList.remove('is-on'));
      }
    };

    root.querySelectorAll('.sw-season').forEach((block) => {
      const idx = block.dataset.season;
      const pill = block.querySelector('.sw-pill');

      block.addEventListener('mouseenter', () => setSeason(idx));
      block.addEventListener('mouseleave', () => setSeason(null));
      block.addEventListener('focusin', () => setSeason(idx));
      block.addEventListener('focusout', () => setSeason(null));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-shoreline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.currentScript.closest('.shopify-section') || document;
    const section = root.querySelector('.sl');
    if (!section || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          section.classList.add('is-live');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    io.observe(section);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harbor-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initAtelier = (root) => {
    if (!root || root.dataset.motionReady === 'true') return;
    root.dataset.motionReady = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = root.querySelectorAll('.atelier-intro > *, .atelier-duo__card, .atelier-market header, .atelier-products article, .atelier-origin > *, .atelier-chronicle > header, .atelier-chronicle__image, .atelier-chronicle__chapters article, .atelier-serve > *, .atelier-closing > *');
    targets.forEach((item) => {
      item.classList.add('atelier-reveal');
      if (item.matches('.atelier-duo__card, .atelier-chronicle__image, .atelier-closing__image')) item.classList.add('atelier-reveal--image');
    });
    root.classList.add('is-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach((item) => observer.observe(item));
  };
  document.querySelectorAll('.atelier').forEach(initAtelier);
  document.addEventListener('shopify:section:load', (event) => initAtelier(event.target.querySelector('.atelier')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
